class SizeVariantDropdown extends VariantSelector {
  constructor() {
    super();
    this.property = 'size';
    this.value = false;
    this.displayValue = false;
    this.formId = this.getAttribute('form-id');
    this.unavailableText = this.getAttribute('unavailable-text');
    this.defaultLabel = this.getAttribute('default-label');
    this.options = [];
    this.wrapper = this.querySelector('.product-size-dropdown');
    this.tooltip = this.querySelector('.product-size-dropdown__tooltip');
    this.label = this.querySelector('.product-size-dropdown__label');
    this.dropdown = this.querySelector('.product-size-dropdown__select');
    this.sr = this.querySelector('.product-size-dropdown__sr');
  }


  setValue(value){
    super.setValue(value);
    const selected = this.dropdown.querySelector(`option[value="${value}"]`);
    if (this.dropdown.value != value){
      this.dropdown.value = value;
    }
    this.updateLabel();
  }

  deduplicateOptions(rawOptions) {
    const labelMap = new Map();
    rawOptions.forEach(option => {
      if (!labelMap.has(option.label)) {
        labelMap.set(option.label, { best: option, codes: [option.value] });
      } else {
        const entry = labelMap.get(option.label);
        entry.codes.push(option.value);
        if (option.enabled && !entry.best.enabled) {
          entry.best = option;
        }
      }
    });
    return Array.from(labelMap.values());
  }

  getOptionLabel(option) {
    if (option.enabled) return option.label;
    return `${option.label} - ${this.unavailableText}`;
  }

  render() {
    const rawOptions = window.variants.getVariantData(this.property);
    const options = this.deduplicateOptions(rawOptions);
    let markup = `<option value="" disabled selected>${this.defaultLabel}</option>`;
    options.forEach(({ best, codes }, index) => {
      const selectorID = `selector-${this.property}-${index}`;
      const valueLabel = this.getOptionLabel(best);

      // This may be extended later to support hard-unavailable which would be OOS items.
      const availState = best.enabled ? 'available' : 'soft-unavailable';
      markup += `<option id="${selectorID}" value="${best.value}" data-label="${best.label}" data-codes="${codes.join(',')}" name="${this.property}-option" data-disabled="${(best.enabled ? 0 : 1)}" data-availability="${availState}">${valueLabel}</option>`;
    });

    this.dropdown.insertAdjacentHTML('beforeend', markup);

    this.dropdown.classList.toggle('hidden', options.length === 0);

    /* Set options to enable event listener attachment. */
    this.options = [this.dropdown];

    this.dropdown.addEventListener('change', this.onValueChanged.bind(this));

    this.label.textContent = this.defaultLabel;
    this.updateUrls();
  }

  updateUrls(){
    // Updates the url of non available colors and clears dropdown selection when navigating a not available color variant.
    const baseUrl = `${Shopify.routes.root}products`;

    const options = window.variants.getVariantData("color");
    options.forEach((option) => {
      if (option.enabled) return;
      const element = document.querySelector(`[href*="${option.dynamicHandle}"]`);
      if (element){
        const color = option.label.trim().toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
        element.setAttribute('href', `${baseUrl}/${option.dynamicHandle}?&color=${color}`);
      }
    });
  }

  updateOptions(event){
    if (event.detail.property != this.property){
      const rawOptions = window.variants.getVariantData(this.property);
      const deduped = this.deduplicateOptions(rawOptions);

      deduped.forEach(({ best, codes }) => {
        // Find the DOM option by current value or by any previously assigned code
        let input = this.dropdown.querySelector(`option[value="${best.value}"]`);
        if (!input) {
          input = Array.from(this.dropdown.options).find(opt =>
            opt.dataset.codes && opt.dataset.codes.split(',').some(c => codes.includes(c))
          );
        }
        if (!input) return;

        // Update value and codes to reflect the best option for this color
        input.value = best.value;
        input.dataset.codes = codes.join(',');

        const valueLabel = this.getOptionLabel(best);
        const availState = best.enabled ? 'available' : 'soft-unavailable';
        input.textContent = valueLabel;
        input.setAttribute('data-disabled', best.enabled ? 0 : 1);
        input.setAttribute('data-availability', availState);
      });

      this.updateUrls();
      this.updateLabel();

      // Auto-select if only one option is available and nothing is selected
      if (!this.value) {
        const enabledOptions = deduped.filter(({ best }) => best.enabled);
        if (enabledOptions.length === 1) {
          this.setValue(enabledOptions[0].best.value);
          window.variants.setVariantOption(this.property, this.value);
        }
      }
    }
  }

  deselect() {
    super.deselect();
    this.dropdown.selectedIndex = 0; // Reset to "Select a size" placeholder
    this.label.textContent = this.defaultLabel;
  }

  updateSelected(event){
    if (event.detail.property == this.property){
      const code = event.detail.code;
      // Try direct match first, then fall back to data-codes lookup for deduplicated options
      const matchingOption = this.dropdown.querySelector(`option[value="${code}"]`) ||
        Array.from(this.dropdown.options).find(opt =>
          opt.dataset.codes && opt.dataset.codes.split(',').includes(code)
        );
      this.dropdown.value = matchingOption ? matchingOption.value : code;
      this.updateLabel();
    }
  }

  updateLabel() {
    this.displayValue = this.dropdown.options[this.dropdown.selectedIndex].textContent;
    this.tooltip.dataset.acsbTooltip = `${this.property}: ${this.displayValue}`;
    this.label.textContent = this.displayValue;
    this.dropdown.dataset.acsbTooltip = this.displayValue;
    this.sr.dataset.textContent = `${this.property}: ${this.displayValue}`;
  }

  onValueChanged(event){
    const selectedOption = this.dropdown.options[this.dropdown.selectedIndex];
    const availability = selectedOption?.getAttribute('data-availability');

    if (availability === 'soft-unavailable') {
      // Soft unavailable: resolve conflict instead of normal variant option set
      this.handleSoftUnavailableClick(this.dropdown.value);
      this.updateLabel();
      this.updateUrls();
      return;
    }

    this.setValue(this.dropdown.value);
    window.variants.setVariantOption(this.property, this.value);
    this.updateUrls();
  }
}

customElements.define('size-variant-dropdown', SizeVariantDropdown);
